import { createReducer } from "reduxsauce";
import _ from "lodash";
import ReducerRegister from "../../../ReducerRegister";
import MessageService from "../../../../services/screens/admin/bbs/MessageService";
import DetailsService from "../../../../services/screens/admin/bbs/DetailsService";
import { ActionTypes } from "../../../actionTypes/screens/admin/bbs/MessageActionTypes";
import AsyncActionReducers from "../../../AsyncActionReducers";
import Constants from "../../../../config/Constants";
import UIDs from "../../../../UIDs";

const uid = UIDs.screens.admin.bbs.message;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: searchVO => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, searchVO });

            MessageService.loadScreenView(
                searchVO,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response, searchVO));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: (data, searchVO) => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data,
        searchVO
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    deleteAsync: (vo) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.DELETE_ASYNC, vo });

            MessageService.deletemessage(
                vo,
                response => {
                    dispatch(Actions.deleteSuccess(vo));
                },
                error => {
                    dispatch(Actions.deleteFailure(error));
                }
            );
        };
    },

    deleteSuccess: (vo) => ({
        type: ActionTypes.DELETE_SUCCESS,
        parentType: ActionTypes.DELETE_ASYNC,
        postReducer: deleteSuccessPostReducer,
        vo
    }),

    deleteFailure: error => ({
        type: ActionTypes.DELETE_FAILURE,
        parentType: ActionTypes.DELETE_ASYNC,
        error
    }),

    likeAsync: (vo) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LIKE_ASYNC, vo });

            DetailsService.addLike(
                vo,
                response => {
                    dispatch(Actions.likeSuccess(vo));
                },
                error => {
                    dispatch(Actions.likeFailure(error));
                }
            );
        };
    },

    likeSuccess: (vo) => ({
        type: ActionTypes.LIKE_SUCCESS,
        parentType: ActionTypes.LIKE_ASYNC,
        postReducer: likeAsyncSuccessPostReducer,
        vo
    }),

    likeFailure: error => ({
        type: ActionTypes.LIKE_FAILURE,
        parentType: ActionTypes.LIKE_ASYNC,
        error
    }),

    deleteLikeAsync: (vo) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.DELETE_LIKE_ASYNC, vo });

            DetailsService.deleteLike(
                vo,
                response => {
                    dispatch(Actions.deleteLikeSuccess(vo));
                },
                error => {
                    dispatch(Actions.deleteLikeFailure(error));
                }
            );
        };
    },

    deleteLikeSuccess: (vo) => ({
        type: ActionTypes.DELETE_LIKE_SUCCESS,
        parentType: ActionTypes.DELETE_LIKE_ASYNC,
        postReducer: deleteLikeAsyncPostReducer,
        vo
    }),

    deleteLikeFailure: error => ({
        type: ActionTypes.DELETE_LIKE_FAILURE,
        parentType: ActionTypes.DELETE_LIKE_ASYNC,
        error
    }),

    replyAsync: (vo) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.REPLY_ASYNC, vo });

            DetailsService.addReply(
                vo,
                response => {
                    dispatch(Actions.replySuccess(response, vo));
                },
                error => {
                    dispatch(Actions.replyFailure(error));
                }
            );
        };
    },

    replySuccess: (data, vo) => ({
        type: ActionTypes.REPLY_SUCCESS,
        parentType: ActionTypes.REPLY_ASYNC,
        postReducer: replySuccessPostReducer,
        data,
        vo
    }),

    replyFailure: error => ({
        type: ActionTypes.REPLY_FAILURE,
        parentType: ActionTypes.REPLY_ASYNC,
        error
    }),

    setMessageId: value => ({
        type: ActionTypes.SET_MESSAGE_ID,
        value
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    messageId: "",
    messageList: [],
    totalCount: 0,
    searchVO: {
        pageIndex: 1,
        pageSize: Constants.DefaultPageSize,
        partnerId: "",
    },
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data, searchVO }) => {
    return { ...state,
        messageList: data.pagedMessages.messageList,
        totalCount: data.pagedMessages.totalCount,
        searchVO,
    };
};

const deleteSuccessPostReducer = (state, { vo }) => {
    const { messageList, totalCount } = state;
    let newMessageList = _.clone(messageList);
    let newTotalCount = totalCount;
    if(vo.deleteAll){
        newMessageList = [];
        newTotalCount = 0;
    }else{
        let index = newMessageList.length - 1;
        while (index >= 0) {
            if (newMessageList[index].id === vo.messageId)
            newMessageList.splice(index, 1);
            index -= 1;
        }
        newTotalCount = newTotalCount - 1;
    }

    return { ...state, messageList: newMessageList, totalCount: newTotalCount };
};

const likeAsyncSuccessPostReducer = (state, { vo }) => {
    let {messageList} = state;
    let newMessageList = _.clone(messageList);
    let index = newMessageList.length - 1;
    while (index >= 0) {
        if (newMessageList[index].id === vo.messageId){
            if(vo.src === "replyInfo"){
                newMessageList[index].replyInfo.isMyLike = true;
            }else if(vo.src === "toReplyInfo"){
                newMessageList[index].toReplyInfo.isMyLike = true;
            }
        }
        index -= 1;
    }
    return { ...state, messageList: newMessageList}
};

const deleteLikeAsyncPostReducer = (state, { vo }) => {
    let {messageList} = state;
    let newMessageList = _.clone(messageList);
    let index = newMessageList.length - 1;
    while (index >= 0) {
        if (newMessageList[index].id === vo.messageId){
            if(vo.src === "replyInfo"){
                newMessageList[index].replyInfo.isMyLike = false;
            }else if(vo.src === "toReplyInfo"){
                newMessageList[index].toReplyInfo.isMyLike = false;
            }
        }
        index -= 1;
    }

    return { ...state, messageList: newMessageList}
};

const replySuccessPostReducer = (state, { data, vo }) => {
    return { ...state };
    /*let {messageList} = state;
    let newMessageList = _.clone(messageList);
    let index = newMessageList.length - 1;
    let addRelyInfo = {
        id: data.id,
        data: data.data,
        postId: vo.postId,
        fromUserId: data.fromUserId,
        fromUserName: data.fromUserName,
        fromUserIcon: data.fromUserIcon,
        toReplyId: vo.replyId,
        likeCount: data.likeCount,
        isMyLike: data.isMyLike,
        toUserId: data.toUserId,
        toUserName: data.toUserName,
    }
    while (index >= 0) {
        if (newMessageList[index].id === vo.messageId){
            let newAddReplyInfo = newMessageList[index]["addRelyInfo"] ? newMessageList[index]["addRelyInfo"] : [];
            newAddReplyInfo.unshift(addRelyInfo);
            newMessageList[index]["addRelyInfo"] = newAddReplyInfo;
        }
        index -= 1;
    }
    return { ...state, messageList: newMessageList}*/
};

const setMessageIdReducer = (state, { value }) => {
    return { ...state, messageId: value };
};
// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.DELETE_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.DELETE_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.DELETE_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.LIKE_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LIKE_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LIKE_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.DELETE_LIKE_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.DELETE_LIKE_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.DELETE_LIKE_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.REPLY_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.REPLY_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.REPLY_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SET_MESSAGE_ID]: setMessageIdReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
